'use strict';

import fixProductHeight from './fix-product-height';
import { hasSize } from '../lib/is-mobile';
import convertProductRatio from '../lib/convert-product-ratio';



export default function fixProductsAlignment () {
    // Product overview
    fixProductHeight('.product-overview:not(.search) .product .title');
    fixProductHeight('.product-overview:not(.search) .product .delivery');


    let searchColumns = 4;

    if ( hasSize('sm') ) {
        searchColumns = 2;
    }

    if ( hasSize('xs') ) {
        searchColumns = 1;
    }

    // Product search
    fixProductHeight('.search-results .product-overview .product .title', searchColumns);
    fixProductHeight('.search-results .product-overview .product .delivery', searchColumns);

    // Product compare
    fixProductHeight('.compare-slider .product-overview .product .title');
    fixProductHeight('.compare-slider .product-overview .product .delivery_out');
    fixProductHeight('.compare-slider .product-overview .product .specs');

    // Products row
    fixProductHeight('.products-row.new .product .title', searchColumns);
    fixProductHeight('.products-row.new .product .delivery', searchColumns);
    fixProductHeight('.products-row.sales .product .title', searchColumns);
    fixProductHeight('.products-row.sales .product .delivery', searchColumns);

    const categoryImages = document.querySelectorAll('.category-overview .category img');
    convertProductRatio(categoryImages);
}
